import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.375 6.875L7.5 8L10.5 5L7.5 2L6.375 3.125L7.5 4.25C6.30653 4.25 5.16193 4.72411 4.31802 5.56802C3.47411 6.41193 3 7.55653 3 8.75H4.5C4.5 7.95435 4.81607 7.19129 5.37868 6.62868C5.94129 6.06607 6.70435 5.75 7.5 5.75L6.375 6.875Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M13.5 7.25H12C12 8.04565 11.6839 8.80871 11.1213 9.37132C10.5587 9.93393 9.79565 10.25 9 10.25L10.125 9.125L9 8L6 11L9 14L10.125 12.875L9 11.75C10.1935 11.75 11.3381 11.2759 12.182 10.432C13.0259 9.58807 13.5 8.44347 13.5 7.25Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
